import { render } from "./MaintenanceNote.vue?vue&type=template&id=d63cb296&scoped=true"
import script from "./MaintenanceNote.vue?vue&type=script&lang=js"
export * from "./MaintenanceNote.vue?vue&type=script&lang=js"

import "./MaintenanceNote.vue?vue&type=style&index=0&id=d63cb296&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d63cb296"]])

export default __exports__